import React, { Component } from 'react';
import './GoToTop.css';

class GoToTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll(); // Check initial scroll position
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isVisible = scrollTop > 300; // Show button after scrolling 300px
    this.setState({ isVisible });
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  render() {
    const { isVisible } = this.state;

    if (!isVisible) {
      return null;
    }

    return (
      <button
        className="go-to-top-btn"
        onClick={this.scrollToTop}
        aria-label="Ir para o topo"
        title="Ir para o topo"
      >
        <i className="fas fa-arrow-up"></i>
      </button>
    );
  }
}

export default GoToTop;

